import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss', '../platform.component.scss']
})
export class ContactComponent implements OnInit {

  mode: number = 0;
  constructor(
    private router: Router,
  ) { 
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      setTimeout(() => {
        const jumpTop = document.getElementById('jump-top');
        if (jumpTop) {
          jumpTop.scrollIntoView({ behavior: 'smooth' });
        }
      }, 10);
    });
  }

  ngOnInit(): void {
  }
  toggleContact(){
  }
  moveContact(){
    this.router.navigate(["pages/platform/contact"]);
  }
  getManualSchool() {
    window.open("")
  }
  getManualSupport() {
    window.open("")
  }
}
